import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {MutableRefObject, useEffect, useRef} from 'react'
import {ToggleComponent} from '../../../assets/ts/components'

import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import {useAuth} from '../../../../app/modules/auth'
import {getDefaultLandingRoute} from '../../../../app/routing/routeHelper'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const {config} = useLayout()
  const {mode} = useThemeMode()
  const toggleRef = useRef<HTMLDivElement>(null)
  const {currentUser} = useAuth()
  const landingRoute = getDefaultLandingRoute(currentUser)

  const isDark =
    mode === 'dark' ||
    (mode === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    // Sync initial active class based on body attribute
    if (toggleRef.current) {
      if (document.body.getAttribute('data-kt-app-sidebar-minimize') === 'on') {
        toggleRef.current.classList.add('active')
      } else {
        toggleRef.current.classList.remove('active')
      }
    }
  }, [])

  const handleToggleSidebar = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const body = document.body
    const isMinimized = body.getAttribute('data-kt-app-sidebar-minimize') === 'on'

    if (props.sidebarRef.current) {
      props.sidebarRef.current.classList.add('animating')
      setTimeout(() => {
        props.sidebarRef.current?.classList.remove('animating')
      }, 300)
    }

    if (isMinimized) {
      body.removeAttribute('data-kt-app-sidebar-minimize')
      toggleRef.current?.classList.remove('active')
    } else {
      body.setAttribute('data-kt-app-sidebar-minimize', 'on')
      toggleRef.current?.classList.add('active')
    }
  }

  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      <Link to={landingRoute} className='d-flex align-items-center' title='Home'>
        <img
          alt='Logo'
          src={toAbsoluteUrl(isDark ? '/media/logos/logo_dark.png' : '/media/logos/logo.png')}
          className='h-30px h-lg-40px app-sidebar-logo-default'
        />
        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/logos/favicon.png')}
          className='h-20px app-sidebar-logo-minimize'
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          onClick={handleToggleSidebar}
          role='button'
          tabIndex={0}

          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle sidebar-toggle-btn',
            {active: appSidebarDefaultMinimizeDefault}
          )}
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          {/* ICON BURGER (GARIS 3) */}
          <i className='bi bi-list fs-2 fw-bolder pe-none'></i>
        </div>
      )}
    </div>
  )
}

export {SidebarLogo}

